import { OrderStatusState, OrderStatusTypes, OrderStatusActionTypes } from './types'
import { Reducer } from 'redux'

const initialState: OrderStatusState = {
  orderStatusList: []
}

type ReducerOpts = Reducer<OrderStatusState, OrderStatusActionTypes>
const reducer: ReducerOpts = (state = initialState, action: OrderStatusActionTypes): OrderStatusState => {
  let index = -1
  switch (action.type) {
    case OrderStatusTypes.ORDER_STATUS_CREATE:
      return {
        ...state,
        orderStatusList: [...state.orderStatusList, action.payload]
      }
    case OrderStatusTypes.ORDER_STATUS_UPDATE:
      index = state.orderStatusList.findIndex(obj => obj.id === action.payload.id)
      return {
        ...state,
        orderStatusList: [
          ...state.orderStatusList.slice(0, index),
          action.payload,
          ...state.orderStatusList.slice(index + 1)
        ]
      }
    case OrderStatusTypes.ORDER_STATUS_DELETE:
      index = state.orderStatusList.findIndex(obj => obj.id === action.payload)
      return {
        ...state,
        orderStatusList: [
          ...state.orderStatusList.slice(0, index),
          ...state.orderStatusList.slice(index + 1)
        ]
      }
    case OrderStatusTypes.ORDER_STATUS_GET:
      return { ...state, orderStatus: action.payload }
    case OrderStatusTypes.ORDER_STATUS_GET_LIST:
      return { ...state, orderStatusList: action.payload }
    default:
      return state
  }
}

export default reducer
